import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/markdown': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M593.8 59.1c25.5 0 46.2 20.7 46.2 46.1v301.6c0.1 25.4-20.6 46.1-46.1 46.1h-547.7c-25.5 0-46.2-20.7-46.2-46.2v-301.5c0-25.4 20.7-46.1 46.2-46.1h547.6zM338.5 360.6h-0.2v-209.2h-61.5l-61.5 76.9-61.5-76.9h-61.5v209.2h61.7v-120l61.5 76.9 61.5-76.9v120h61.5zM473.8 363.7l92.2-107.7h-61.5v-104.6h-61.5v104.6h-61.5z'
      }
    ]
  }
})
